import * as React from "react";
import { PickerTimeProps } from "antd/es/date-picker/generatePicker";

import { DatePicker } from "./DatePicker";

export type TimePickerProps = Omit<PickerTimeProps<Date>, "picker">;

export const TimePicker = React.forwardRef<any, TimePickerProps>((props, ref) => {
  return (
    <DatePicker
      {...props}
      picker="time"
      mode={undefined}
      ref={ref}
    />
  );
});

TimePicker.displayName = "TimePicker";
